import React from 'react';
import OrderBox from "./OrderBox";
import IconName from "../../../svgLogo/SvgLogo";
import Profile from "../Profile";

const Orders = () => {
    return (
        <div className="orders-wrapper">
            <Profile/>
            <div className="container orders-container">
                <div className="status-order-tab xmb-14 xmb-lg-10">
                    <nav className="nav-links">
                        <div className="swiper orders-status-swiper">
                            <ul className="swiper-wrapper justify-content-between nav nav-tabs" id="tab-profile"
                                role="tablist">
                                <li className="nav-item swiper-slide" role="presentation">
                                    <div className="nav-link" id="nav-payment-tab"
                                         data-bs-toggle="tab"
                                         data-bs-target="#nav-payment" role="tab"
                                         aria-controls="nav-payment" aria-selected="true">
                                        <IconName name="monetization_on"
                                                  className="icon d-inline-block d-lg-none xml-1"/>
                                        <span className="text d-none d-lg-inline-block">در انتظار پرداخت</span>
                                        <span className="text d-inline-block d-lg-none">پرداخت</span>
                                        <span className="number persian-number">4</span>
                                    </div>
                                </li>
                                <li className="nav-item swiper-slide" role="presentation">
                                    <div className="nav-link active" id="nav-processing-tab"
                                         data-bs-toggle="tab"
                                         data-bs-target="#nav-processing" role="tab"
                                         aria-controls="nav-processing" aria-selected="true">
                                        <IconName name="widgets" className="icon d-inline-block d-lg-none xml-1"/>
                                        <span className="text text d-none d-lg-inline-block">درحال آماده سازی</span>
                                        <span className="text d-inline-block d-lg-none">آماده سازی</span>
                                        <span className="number persian-number">1</span>
                                    </div>
                                </li>
                                <li className="nav-item swiper-slide" role="presentation">
                                    <div className="nav-link" id="nav-delivery-tab"
                                         data-bs-toggle="tab"
                                         data-bs-target="#nav-delivery" role="tab"
                                         aria-controls="nav-delivery" aria-selected="true">
                                        <IconName name="package" className="icon d-inline-block d-lg-none pack xml-1"/>
                                        <span className="text text d-none d-lg-inline-block">درحال بسته بندی</span>
                                        <span className="text d-inline-block d-lg-none">بسته بندی</span>
                                        <span className="number persian-number">1</span>
                                    </div>
                                </li>
                                <li className="nav-item swiper-slide" role="presentation">
                                    <div className="nav-link" id="nav-return-tab"
                                         data-bs-toggle="tab"
                                         data-bs-target="#nav-return" role="tab"
                                         aria-controls="nav-return" aria-selected="true">
                                        <IconName name="local_shipping"
                                                  className="icon d-inline-block d-lg-none xml-1"/>
                                        <span className="text text d-none d-lg-inline-block">ارسال شده</span>
                                        <span className="text d-inline-block d-lg-none">ارسال</span>
                                        <span className="number persian-number">0</span>
                                    </div>
                                </li>
                                <li className="nav-item swiper-slide" role="presentation">
                                    <div className="nav-link" id="nav-cancel-tab"
                                         data-bs-toggle="tab"
                                         data-bs-target="#nav-cancel" role="tab"
                                         aria-controls="nav-cancel" aria-selected="true">
                                        <IconName name="check_circle"
                                                  className="icon d-inline-block d-lg-none xml-1"/>
                                        <span className="text text d-none d-lg-inline-block">تکمیل شده</span>
                                        <span className="text d-inline-block d-lg-none">تکمیل</span>
                                        <span className="number persian-number">1</span>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
                <div className="tab-content" id="nav-orders">
                    <div className="tab-pane fade show" id="nav-payment"
                         role="tabpanel" aria-labelledby="nav-payment-tab">
                        <OrderBox/>
                        <OrderBox/>
                    </div>
                    <div className="tab-pane fade show active" id="nav-processing"
                         role="tabpanel" aria-labelledby="nav-processing-tab">
                        <OrderBox/>
                        <OrderBox/>
                        <OrderBox/>
                    </div>
                    <div className="tab-pane fade show" id="nav-delivery"
                         role="tabpanel" aria-labelledby="nav-delivery-tab">
                        <OrderBox/>
                    </div>
                    <div className="tab-pane fade show" id="nav-return"
                         role="tabpanel" aria-labelledby="nav-return-tab">
                    </div>
                    <div className="tab-pane fade show" id="nav-cancel"
                         role="tabpanel" aria-labelledby="nav-cancel-tab">
                        <OrderBox/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Orders;
